import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CityComponent } from '@/new-transport/_shared/city-map/city/city.component';
import { City } from '@/new-transport/_models/transport-map.model';
import { VehicleInUseComponent } from '@/new-transport/_shared/vehicle-in-use/vehicle-in-use.component';
import { VehicleTransport } from '@/new-transport/_models/transport.model';

@Component({
	selector: 'app-city-map',
	standalone: true,
	imports: [CityComponent, VehicleInUseComponent],
	templateUrl: './city-map.component.html',
	styleUrl: './city-map.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CityMapComponent {
	readonly cities = input.required<City[]>();
	readonly vehicleInUse = input.required<VehicleTransport>();

	readonly citiesGrid = computed(() => {
		if (!this.cities().length) return [];

		const citiesGrid: City[][] = [];
		const COLS_AMOUNT = Math.max(...this.getCoordinatesArr('cols'));
		const ROWS_AMOUNT = Math.max(...this.getCoordinatesArr('rows'));

		for (let i = 0; i < ROWS_AMOUNT; i++) {
			citiesGrid[i] = [];
			for (let j = 0; j < COLS_AMOUNT; j++) {
				const found = this.cities().find((city) => city.erpGrid[0] === j && city.erpGrid[1] === i);
				citiesGrid[i][j] = found ? found : null;
			}
		}

		return citiesGrid;
	});

	private getCoordinatesArr(type: 'cols' | 'rows'): number[] {
		const index = type === 'cols' ? 0 : 1;
		return this.cities()
			.filter((stop) => stop.erpGrid)
			.map((city) => city.erpGrid[index])
			.filter((coord) => typeof coord === 'number')
			.map((coord) => coord + 1);
	}
}
